import { TableColumn } from '../../../core/interfaces/dynamic-table';

export const ConfigFeatureKey = 'auditTrailConfig';

export const AUDIT_PATH = '../../../../assets/json/audit-trail/audit-trail.json';

export interface ConfigState {
    tableConfigs: TableColumn[];
}
